import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SaleSquareOauthPageRoutingModule } from './sale-square-oauth-routing.module';

import { SaleSquareOauthPage } from './sale-square-oauth.page';

import { SalonMonsterCheckMarkLoaderModule } from '../../../components/smr-checkmark-loader/smr-checkmark-loader.module';

import { SalonMonsterTapRetryModule } from '../../../components/smr-tap-retry/smr-tap-retry.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
// import { SafariViewController } from '@awesome-cordova-plugins/safari-view-controller';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SaleSquareOauthPageRoutingModule,
    SalonMonsterCheckMarkLoaderModule,
    SalonMonsterTapRetryModule
  ],
  declarations: [SaleSquareOauthPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
})
export class SaleSquareOauthPageModule {}
